import { render } from "./PanelBundleMetadata.vue?vue&type=template&id=21a6feea&scoped=true&ts=true"
import script from "./PanelBundleMetadata.vue?vue&type=script&lang=ts"
export * from "./PanelBundleMetadata.vue?vue&type=script&lang=ts"

import "./PanelBundleMetadata.vue?vue&type=style&index=0&id=21a6feea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a6feea"]])

export default __exports__